import api from "../../instance/api";
import {
  startOrgKycUsersList,
  successOrgKycUsersList,
  errorOrgKycUsersList,
} from "../../slice/Kyc-Users/index";

// Organisation is derived server-side from the admin's own token — no
// organisationId param is sent from the frontend.
const getOrgKycUsersListApi = (filters = {}) => async (dispatch) => {
  dispatch(startOrgKycUsersList());

  try {
    const res = await api.get(`/user/admin-kyc-dashboard`, {
      params: {
        name: filters.name || undefined,
        kycStatus: filters.kycStatus || undefined,
        cardStatus: filters.cardStatus || undefined,
        page: filters.page ?? 0,
        size: filters.size ?? 10,
      },
    });

    const payload = {
      list: res?.data?.content || [],
      total: res?.data?.totalElements || 0,
    };
    dispatch(successOrgKycUsersList(payload));
  } catch (err) {
    dispatch(errorOrgKycUsersList(err?.response?.data?.message));
  }
};

export { getOrgKycUsersListApi };
